export default __webpack_public_path__ + "static/media/setup_blue.645408a2.svg";